import { useSelector } from 'react-redux';
import { IStore } from '../../../store/interface';
import { ILotteryEntity, LotteryType } from '../../interfaces';
import { getActingLotteryElement } from '../../ducks/lottery';

export const useActingLotteryElement = (type: LotteryType) => ({
  data: useSelector<IStore, ILotteryEntity>(getActingLotteryElement(type)),
});
